import { AxiosError } from 'axios';
import { PaginatedData } from 'web-library/models/List';
import { ApiPathParam } from 'web-library/models/SearchParamSchema';
import { POST_DATA_ARCHIVAL_LISTING_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request / Response
// =============================================================================

interface Payload {
  examYear: string | null;
  examLevels: string[];
  apiPathParam: ApiPathParam;
}

interface Input {
  onSuccess?: (data: PaginatedData<DataArchivalEntry>) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

interface DataArchivalEntry {
  uuid: string;
  examYear: string;
  examLevel: string;
  createdDateTime: string;
  requestBy: string;
  lastUpdatedDateTime: string;
  updatedBy: string;
  status: string;
}

// =============================================================================
// Mutation
// =============================================================================
export const usePostDataArchivalListing = ({ onSuccess, onError }: Input) => {
  const postDataArchivalListing = async (payload: Payload) => {
    const res = await axiosClient.post<PaginatedData<DataArchivalEntry>>(
      POST_DATA_ARCHIVAL_LISTING_URL(payload.apiPathParam),
      {
        examYear: payload.examYear,
        examLevels: payload.examLevels,
      }
    );
    return res.data;
  };

  return useCustomMutation(postDataArchivalListing, {
    onSuccess,
    onError,
  });
};
